import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteGroupsDialog.module.css';
import { useDeleteGroupListMutation } from '../../../generated/graphql';

type DeleteGroupsDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,

    ids: string[],
};

const DeleteGroupsDialog = (props: DeleteGroupsDialogProps) => {
    const { style, visible, ids, onClose } = props;
    const [deleteGroups, deleteGroupsResult] = useDeleteGroupListMutation({
        variables: {
            ids: ids
        }
    });

    const handleOnYesClick = () => {
        deleteGroups()
            .then(res => onClose())
            .catch(err => { });
    };

    return (
        <DialogBase
            title="Delete Groups"
            type="YesNo"
            visible={visible}
            onClose={onClose}
            onYesClick={handleOnYesClick}
            isLoading={deleteGroupsResult.loading}
            className={styles.DeleteGroupsDialog}
            style={style}
            data-testid="DeleteGroupsDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete these groups?</p>
        </DialogBase>
    );
};

export default DeleteGroupsDialog;